const autocompleteActionModalFilter = {
  sites: 'Sitios',
  users: 'Responsable',
  equipments: 'Tipo de equipo',
  place: 'Lugar',
  areas: 'Departamentos',
  status: 'Status Acciones',
  statusMaintenances: 'Status Mantenimientos',
  maintenanceCreatedBy: 'Mantenimiento Creado por',
};

export default autocompleteActionModalFilter;
